exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user-permissions{position:relative;columns:200px 3}.user-permissions>*{display:block;margin:0;word-break:break-word;padding-top:4px}@media screen and (min-width:425px){.user-permissions>*{padding-top:calc(3.16256px + .19704vw)}}@media screen and (min-width:1440px){.user-permissions>*{padding-top:6px}}.user-permissions>*{padding-bottom:4px}@media screen and (min-width:425px){.user-permissions>*{padding-bottom:calc(3.16256px + .19704vw)}}@media screen and (min-width:1440px){.user-permissions>*{padding-bottom:6px}}", ""]);

// exports
